import React from 'react';
import { useSelector } from 'react-redux';
import { selectActiveUploads } from '../../store/upload/uploadSlice';
import { motion, AnimatePresence } from 'framer-motion';

const GlobalUploadBanner = () => {
  const activeUploads = useSelector(selectActiveUploads);
  const uploadingItems = activeUploads.filter(u => u.status === 'uploading');

  // Calculate average progress if multiple uploads
  const averageProgress = uploadingItems.length > 0
    ? Math.round(
        uploadingItems.reduce((sum, u) => sum + (u.progress || 0), 0) /
        uploadingItems.length
      )
    : 0;

  if (uploadingItems.length === 0) {
    return null;
  }

  return (
    <AnimatePresence>
      <motion.div
        initial={{ y: -100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: -100, opacity: 0 }}
        transition={{ duration: 0.3 }}
        className="fixed top-0 left-0 right-0 z-[9999] bg-[#0070BA] text-white shadow-lg"
      >
        <div className="container mx-auto px-4 py-3">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="animate-spin rounded-full h-5 w-5 border-2 border-white border-t-transparent"></div>
              <div>
                <p className="font-medium text-sm">
                  {uploadingItems.length === 1
                    ? 'Uploading video...'
                    : `Uploading ${uploadingItems.length} videos...`}
                </p>
                {uploadingItems.length === 1 && (
                  <div className="w-48 bg-white/20 rounded-full h-1.5 mt-1">
                    <div
                      className="bg-white h-1.5 rounded-full transition-all duration-300"
                      style={{ width: `${averageProgress}%` }}
                    />
                  </div>
                )}
              </div>
            </div>
            {uploadingItems.length > 1 && (
              <span className="text-xs opacity-90">
                {averageProgress}% complete
              </span>
            )}
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default GlobalUploadBanner;
